"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mockShopifyCart = exports.mockShopifyCartLine = void 0;
const test_helpers_1 = require("../test_helpers");
const shopify_variant_1 = require("./shopify_variant");
function mockShopifyCartLine(overrides = {}) {
    return {
        attributes: [],
        cost: {
            totalAmount: { amount: '100.00' },
        },
        discountAllocations: [],
        id: 'mock-cart-line-id' + (0, test_helpers_1.incrementingId)(),
        merchandise: (0, shopify_variant_1.mockShopifyVariant)(),
        quantity: 1,
        ...overrides,
    };
}
exports.mockShopifyCartLine = mockShopifyCartLine;
function mockShopifyCart(overrides = {}) {
    return {
        appliedGiftCards: [],
        checkoutUrl: 'https://example.com/checkout',
        cost: {
            subtotalAmount: { amount: '100.00' },
            totalAmount: { amount: '100.00' },
        },
        discountAllocations: [],
        discountCodes: [],
        id: 'mock-cart-id' + (0, test_helpers_1.incrementingId)(),
        lines: {
            nodes: [mockShopifyCartLine()],
        },
        ...overrides,
    };
}
exports.mockShopifyCart = mockShopifyCart;
